<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="用户账号">
            <a-input :disabled="editStatus" v-decorator="['userNo', rules.userNo]"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="用户名称">
            <a-input v-decorator="['userName', rules.userName]"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="是否使用">
            <a-switch
                v-decorator="['isUse',{ valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="是否系统用户">
            <a-switch
                disabled
                v-decorator="['isSystem',{ valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="所属部门">
            <a-tree-select
                v-decorator="['deptId',rules.deptId]"
                allow-clear
                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                :treeData="treeData"
                :replaceFields="{children:'children', title:'deptName', key:'deptId', value: 'deptId' }"
            >
            </a-tree-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="邮箱">
            <a-input v-decorator="['email', rules.email]"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="手机号">
            <a-input v-decorator="['mobile', rules.phone]"/>
          </a-form-item>
        </a-col>


        <a-col :span="24">
          <a-form-item label="头像"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['headImg']" :accept="'image/*'"></uploader>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="备注"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-textarea v-decorator="['remark', rules.remark]"></a-textarea>
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>

    <a-tabs>
      <a-tab-pane key="1" tab="角色" :forceRender="true">
        <roleTable ref="roleTable" :rowId="rowId"></roleTable>
      </a-tab-pane>
    </a-tabs>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save()">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/comm/userManage';

import roleTable from "@/pages/web/comm/userManage/detail/roleTable";
import {mapState} from "vuex";
import XEUtils from "xe-utils";

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    userNo: {
      rules: [{required: true, message: "请输入用户账号"}]
    },
    userName: {
      rules: [{required: true, message: "请输入用户名称"}]
    },
    remark: {
      rules: [{required: false, max: 255, message: "备注长度不能超过255"}]
    },
    deptId:{
      rules: [{required: true, message: "请选择所属部门"}]
    },
    phone:{
      rules:[{
        required: false,
        trigger: "blur"
      },
        {
          validator: function(rule, value, callback) {
            if (value !=null && value !=="" &&
                /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
                .test(value) == false) {
              callback(new Error("手机号格式错误"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
    },
    email: {
      rules:[{
        required: false,
        trigger: "blur"
      },
        {
          validator: function(rule, value, callback) {
            if (value !=null && value !=="" &&
                /^[A-Za-z0-9-._]+@[A-Za-z0-9-]+(.[A-Za-z0-9]+)*(.[A-Za-z]{2,6})$/i.test(
                    value
                ) == false
            ) {
              callback(new Error("邮箱格式错误"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }
      ]}
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  //给子表赋值
  this.$refs['roleTable'].loadData(entity.roleList);
  this.editStatus = !!entity.userNo;//是否可编辑用户账号
  this.createUserId = entity.createUserId;
  this.createDate = entity.createDate;
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    isUse: true,
    isSystem: false
  }
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity, null, ['isUse', 'isSystem']);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  let menuData = await dataApi.getMenuList();
  this.treeData = XEUtils.toArrayTree(menuData.data, {
    key: 'deptId',
    parentKey: 'parentId',
    children: 'children'
  });
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  //其他数据处理 类似子表放在这里
  vm.$refs["roleTable"].getChildData((child, del) => {
    entities.roleList = child;
    entities.delRoleIdList = del.map(val => {
      return val.id;
    });
  });

  //子表的数据判断
  let defaultArr = entities.roleList.filter((item) => {
    return item.isMain === 1;
  })
  if (defaultArr.length !== 1) {
    throw '至少且只能选择一个默认角色';
  }

  entities.userId = vm.keyId;
  entities.createUserId = vm.createUserId;
  entities.createDate = vm.createDate;
  entities.shopId = this.currUser.shopId;
  await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    roleTable,
    // roleTableModal
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      editStatus: false,
      treeData: [],
      dealer: [],
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
  },
};
</script>

<style scoped lang="less">
</style>